import { render, staticRenderFns } from "./UcContactCard.yaml?vue&type=template&id=18e644da&component"
import script from "./UcContactCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcContactCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports